<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['title']" placeholder="请输入标题"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="文章类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select v-decorator="['type']"  placeholder="请选择文章类型">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="0">生育</a-select-option>
                <a-select-option value="2">儿童</a-select-option>
                <a-select-option value="3">体重</a-select-option>
                <a-select-option value="4">睡眠</a-select-option>
                <a-select-option value="5">脊柱</a-select-option>
                <a-select-option value="6">老年健康管理</a-select-option>
                <a-select-option value="7">疑难病管理</a-select-option>
                
              </a-select>
          </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="缩略图" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['thumbnailPic']"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-model="doctor1" placeholder="请输入医生姓名" @keyup.enter="search" @input="search($event)"></a-input>
              <a-input v-decorator="['doctor']" placeholder="请输入标题" v-show = "false"></a-input>
              <ul v-show = 'showDoctorList'>
                <li v-for="item in doctorList" :key="item.id" :label="item.name" @click="checkDoctor(item.id,item.name)">{{item.name}}</a-option>
                </li>
               </ul>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="视频" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-upload v-decorator="['video']" :trigger-change="true"></j-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['content',{trigger:'input'}]"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JUpload from '@/components/jeecg/JUpload'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JEditor from '@/components/jeecg/JEditor'

  export default {
    name: 'ArticleManagementForm',
    components: {
      JFormContainer,
      JUpload,
      JImageUpload,
      JEditor,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/articleManagement/articleManagement/add",
          edit: "/articleManagement/articleManagement/edit",
          queryById: "/articleManagement/articleManagement/queryById",
          doctorList:'/doctor/doctor/list'
        },
        doctor1:"",
        doctorId:"",
        doctorList:[],
        showDoctorList:false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
      //this.getDoctorList();
    },
    methods: {
      search(event){
        console.log('search12',event.currentTarget.value)
        this.getDoctorList(event.currentTarget.value)
        this.showDoctorList = true
        this.$forceUpdate()
      },
      getDoctorList(name){
        let params = {name:name};
        getAction(this.url.doctorList,params).then((res)=>{
          console.log('doctorList',res)
            if(res.success){
              this.doctorList = res.result.records
              //this.edit (res.result);
            }
          });
      },
      checkDoctor(id,name){
        console.log('checkDoctor',id,name)
        this.doctor1 = name
        this.doctorId = id
        this.$forceUpdate()
        this.showDoctorList = false
      },
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'typeShow','title','thumbnailPic','author','doctor','doctorId','brief','video','content'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }

            let formData = Object.assign(this.model, values);
            formData.doctor = this.doctor1;
            formData.doctorId = this.doctorId;
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'typeShow','title','thumbnailPic','author','doctor','doctorId','brief','video','content'))
      },
    }
  }
</script>
